import type { RuleGraphNodeKind } from "@intelligems/ig-types/dtos/agentic-logic/rule-graph";

/**
 * The uppercase step label the screenshots read by: the KIND says what the
 * step does, so the eyebrow derives from it and never from stored data.
 */
export const KIND_EYEBROWS: Record<RuleGraphNodeKind, string> = {
  input: "CART",
  branch: "WHEN",
  generator: "SHOW",
  filter: "MATCHING",
  sort: "SORTED BY",
  limit: "UP TO",
  exclusions: "EXCLUSIONS",
  output: "WHAT THE SHOPPER SEES",
  "fallback-terminal": "IF NOTHING MATCHES",
};
